module.exports = __webpack_public_path__ + "static/media/Johan&Carma(65).03694e4a.jpg";